import React, { useContext, useEffect, useState,useRef } from "react";
import { useParams } from "react-router-dom";
import '../../css/style.css';
import Menu from "src/components/common/Menu";
import Header from "src/components/common/Header";
import CustomDatePicker from "src/components/common/CustomDatePicker";
import { MenuContext } from "src/context/MenuContext";
import commentIcon from '../../img/icon_comment.png';
import { useDispatch, useSelector } from "react-redux";
import { addDays, format } from "date-fns";
import { getProjects } from "src/store/project";
import { getDailyWorks } from "src/store/schedule";
import { getUsers } from "src/store/user";
import { getMcode } from "src/store/mcode";
import CommentPopup from 'src/components/common/CommentPopup';
import ScrollTop from 'src/components/common/ScrollTop';
import CustomLoader from 'src/components/common/CustomLoader';
import { ValidationMessages } from 'src/components/common/ValidationMessage';

const ScheduleList = () => {

    const { work_date } = useParams();
    const dispatch = useDispatch();
    const { visibleMenu } = useContext(MenuContext);
    const [projectId, setProjectId] = useState(0);
    const [loginUserId, setLoginUserId] = useState(null);
    const [myMemo, setMyMemo] = useState('');
    const [workDate, setWorkDate] = useState(work_date ? new Date(work_date) : new Date());
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [dailyWorkId, setDailyWorkId] = useState(0);
    const [loading, setLoading] = useState(true);
    const [mappedData, setMappedData] = useState([]);
    const [tUserId, setTUserId] = useState(0);
    const [dailyMemo, setDailyMemo] = useState('');
    const [validationMessages, setValidationMessages] = useState([]);
    const calendarRef = useRef(null);
    const workDateFormat = format(workDate, "yyyy-MM-dd")
    const user = useSelector((state) => state.user.data);
    const dailyWork = useSelector((state) => state.schedule.data);
    const holiday = useSelector((state) => state.mcode.data.holiday);
    const isValidDate = (date) => {
        return date instanceof Date && !isNaN(date);
    };
    const param = {
        work_date: workDate,
        id: loginUserId,
    }

    const handleClickOutside = (event) => {
        if (calendarRef.current && !calendarRef.current.contains(event.target)) {
          // If the click is outside the calendar, close it
          setIsCalendarOpen(false);
        }
      };

    useEffect(() => {
          // Add event listener for clicks
          document.addEventListener("mousedown", handleClickOutside);
      
          return () => {
            // Cleanup the event listener on unmount
            document.removeEventListener("mousedown", handleClickOutside);
          };
    }, []);

    // Effect to handle URL params date
    useEffect(() => {
        if (work_date) {
            // Assuming date is in 'yyyy-MM-dd' format in URL
            const parsedDate = new Date(work_date); // Parse the date string to Date object
            if (isValidDate(parsedDate)) {
                setWorkDate(parsedDate); // Set the date in state
            }
        }
    }, [work_date]);

    useEffect(() => {
        setLoading(true);
        dispatch(getUsers());
        dispatch(getProjects());

        dispatch(getDailyWorks(param))
        .then((response) => {
            if(response.error){
                setValidationMessages(response.error.message);
            }
            if (response.payload?.errors) {
              setValidationMessages(response.payload?.errors)
            }
            if(response.payload?.data?.status){
              setLoading(false);
          }
          })
          .catch((error) => {
            setValidationMessages([error.message])
          });

        dispatch(getMcode({ section_cd: 'holiday' }));
    }, [workDate, isPopupOpen]);

    const changeWorkDate = (days) => {
        const newDate = addDays(workDate, days);
        if (isValidDate(newDate)) {
            setWorkDate(newDate);
        } else {
            alert("Invalid date after change", newDate);
        }
    };

    const handleDateChange = (date) => {
        if (isValidDate(date)) {
            setWorkDate(date);
            setIsCalendarOpen(false); // Close calendar after date selection
        } else {
            alert("Invalid selected date", date);
        }
    };

    // Fetch data using useEffect for initial loading
    useEffect(() => {
        const userData = localStorage.getItem('user');
        let loginId = userData ? JSON.parse(userData).id : null;
        setLoginUserId(loginId);
        const userMatch = user.find((val) => val.id === loginId);
        if (userMatch) {
            setMyMemo(userMatch.my_memo);
        }
    }, [user]);

    // Handle form submission (for the project filter)
    const handleProjectFilter = (e) => {
        e.preventDefault();
        setProjectId(parseInt(e.target.value, 10));
    };

    const clickCommentBtn = (event) => {
        const dailyWorkId = event.target.getAttribute('data-id');
        const tUserId = event.target.getAttribute('data-user-id');
        const dailyMemo = event.target.getAttribute('daily-memo');
        setDailyWorkId(dailyWorkId);
        setTUserId(tUserId);
        setDailyMemo(dailyMemo);
        setPopupOpen(true);
    }

    const togglePopup = () => {
        setPopupOpen(false);
    }
    
    useEffect(() => {
        if (dailyWork?.daily_work_list) {
            const filteredData = dailyWork.daily_work_list.filter((val) => val.id === loginUserId);
            if (filteredData.length > 0) {
                filteredData.forEach(dialyWorkId => {
                    setMappedData(dialyWorkId.daily_work_id);
                }); // Setting state only once
            }
        }
    }, [dailyWork?.daily_work_list, loginUserId]);
    return (
        <div className="schedule-list" id="top_schedule-list">
            {validationMessages && validationMessages.length > 0 && (
                <div style={{ background: "#ffe4e2" }}>
                    <ValidationMessages
                        messages={validationMessages}
                        onClose={() => setValidationMessages([])}
                    />
                </div>
            )}
            <div className="wrapper">
                {visibleMenu && <Menu />}
                <div className={visibleMenu ? "menu-open" : "menu-closed"}>
                    <div className="navbar navbar-fixed-top navbar-absolute">
                        <Header sx={{ mb: 4 }} />
                    </div>
                    {loading ? <CustomLoader /> :
                    <>
                    <section className="container-fluid contents-top">
                        <form onSubmit={handleProjectFilter}>
                            <div className="row calender-box">
                                <div className="col-xs-2 text-left"></div>
                                <div className="col-lg-8 col-xs-4 text-center">
                                    <h1 className="input-group datepicker-hl">
                                        {/* Previous Day Button */}
                                        <button
                                            type="button"
                                            onClick={() => changeWorkDate(-1)}
                                            id="before"
                                            className="arrow-button"
                                        >
                                            ←
                                        </button>
                                        &nbsp;
                                        {/* Date Input */}
                                        <input
                                            type="text"
                                            name="work_date"
                                            value={format(workDate, "yyyy/MM/dd EEEE")}
                                            readOnly
                                            onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                                        />
                                        &nbsp;
                                        {/* Next Day Button */}
                                        <button
                                            type="button"
                                            onClick={() => changeWorkDate(1)}
                                            id="next"
                                            className="arrow-button"
                                        >
                                            →
                                        </button>
                                        {/* Calendar Icon */}
                                        <span
                                            className="input-group-addon"
                                            onClick={() => setIsCalendarOpen(!isCalendarOpen)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <span className="glyphicon glyphicon-calendar"></span>
                                        </span>
                                        {/* Date Picker */}
                                        {isCalendarOpen && (
                                            <div ref={calendarRef} style={{ position: "absolute", zIndex: 1000, marginLeft: 52 }}>
                                                <CustomDatePicker
                                                    workDate={workDate}
                                                    handleDateChange={handleDateChange}
                                                    isValidDate={isValidDate}
                                                />
                                            </div>
                                        )}
                                    </h1>
                                </div>
                                <div className="col-xs-2 text-right">
                                    {/* Edit Button */}
                                    <a href={`/scheduleEdit/${(mappedData > 0) ? mappedData : 0}/${workDateFormat}`} className="btn btn-default jq_edit_link">
                                        <span className="glyphicon glyphicon-pencil" aria-hidden="true"></span>
                                    </a>
                                </div>
                            </div>
                            <div style={{ textAlign: 'center' }}>
                                <select name="project_id" style={{ maxWidth: '100%' }} onChange={handleProjectFilter}>
                                    <option value="0">--------</option>
                                    {dailyWork?.project_starting_list?.length > 0 &&
                                        dailyWork.project_starting_list.map((project) => (
                                            <option key={project.project_id} value={project.project_id}>
                                                {`[${project.client_name}] ${project.project_name_abbreviation}`}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                        </form>
                    </section>

                    <section className="container">
                     <p style={{ margin: "10px 0 0 0" }}> 
                        <b>Schedule:</b> Write your planned tasks at the beginning of your workday.<br />
                        <b>Achievements:</b> Report your actual work at the end.<br />
                        Please make sure to record them using the correct date and time.
                     </p>

                        <div>
                            {user?.length > 0 && user?.map((val) => (
                                holiday?.map((holidays) => (
                                    dailyWork?.daily_work_list?.map((dailyWorks) => (
                                        dailyWorks.holiday_cd !== 0 && (
                                            String(dailyWorks.holiday_cd) === holidays.cd &&
                                            dailyWorks.id === val.id &&
                                            (
                                                <div key={val.id}>
                                                    <span className={`statusicon sta-icon${val.icon_num}`}></span>
                                                    <span className="holiday_balloon" style={{ zIndex: 100, marginLeft: 10 }}>
                                                        {`Mr. ${val.name} is on ${holidays.code_value1}`}
                                                    </span>
                                                </div>
                                            )
                                        )
                                    ))
                                ))
                            ))}
                        </div>

                        {/* Memo */}
                        <h2 className="h4 h-style-a" style={{ color: '#d9e021', fontWeight: "bold" }}>
                            <span className="glyphicon glyphicon-pencil" aria-hidden="true"></span> mymemo
                        </h2>
                        <div className="row mb20">
                            <div className="col-xs-12 work-contents">
                                <p className="bg_gray" style={{ whiteSpace: 'pre-wrap', padding: '6px 12px', minHeight: '80px' }}>
                                    {myMemo}
                                </p>
                            </div>
                        </div>

                        <div className="btn-group btn-group-justified" role="group" aria-label="Justified button group with nested dropdown">
                            <a href={`/scheduleInput/${workDateFormat}`} className="btn btn-select jq_plan" role="button">Schedule</a>
                            <a href={`/scheduleEdit/${(mappedData > 0) ? mappedData : 0}/${workDateFormat}`} className="btn btn-default jq_set" role="button">Achievements</a>
                        </div>

                        {user && user.length > 0 && dailyWork?.daily_work_list ? (
                            <table className="table table-bordered" id="top_schedule-list">
                                {dailyWork.daily_work_list.length > 0 ? (
                                    dailyWork.daily_work_list
                                        .filter((val) => projectId === 0 || val.task_list.some(task => task.t_project_id === projectId))
                                        .map((val) => (
                                            <tbody key={`work-${val.id}`}>
                                                <tr>
                                                    <th style={{ backgroundColor: '#f8f8f8' }}>
                                                        <div style={{ display: 'inline-block', margin: '5px 0px 5px 5px', textAlign: 'center' }}>
                                                            <span className={`statusicon sta-icon${val.icon_num}`}></span>&nbsp;
                                                            <a href={`/scheduleDownload/${val.id}`}>{val.name}</a>
                                                        </div>
                                                        <div style={{ margin: '0px 0px 5px 5px' }}>
                                                            {val.work_start_datetime?.slice(11, 16) || ''}
                                                            {val.work_start_datetime && val.work_end_datetime ? ' ～ ' : ''}
                                                            {val.work_end_datetime?.slice(11, 16) || ''}
                                                        </div>
                                                    </th>
                                                    <td className={(val.task_list && val.task_list.length > 0 ? ((val.holiday_cd === 0 || val.holiday_cd === null) ? 'breakdown' : 'holiday') : '')}>
                                                        {val.task_list.length > 0 ? (
                                                            val.task_list
                                                                .slice()
                                                                .sort((a, b) => {
                                                                    const isAZero = a.t_project_id === 0 && a.t_client_id === 0 ? -1 : 1;
                                                                    const isBZero = b.t_project_id === 0 && b.t_client_id === 0 ? -1 : 1;
                                                                    return isAZero - isBZero;
                                                                })
                                                                .reduce(
                                                                    (acc, task) => {
                                                                        if (task.t_project_id === 0 && task.t_client_id === 0) {
                                                                            acc.zeroIndex = acc.zeroIndex ?? 0; // Ensure zeroIndex starts at 0
                                                                            acc.taskList.push({ ...task, displayIndex: 0 });
                                                                        } else {
                                                                            acc.normalIndex++;
                                                                            acc.taskList.push({ ...task, displayIndex: acc.normalIndex });
                                                                        }
                                                                        return acc;
                                                                    },
                                                                    { normalIndex: 0, taskList: [] }
                                                                ).taskList.map((task, index) => {
                                                                    return (
                                                                        <div key={`task-${task.id || index}`} className="task_detail_list" style={{ color: '#999999' }}>
                                                                            <span className="task_detail" style={{ margin: '5px 0px 5px 5px' }}>
                                                                                <em>{task.displayIndex}.</em>
                                                                                {task.t_project_id === 0 && task.t_client_id === 0 && (
                                                                                    <>
                                                                                        {holiday
                                                                                            ?.filter(val => val.cd === task.holiday_cd.toString())
                                                                                            .map((value) => (
                                                                                                <span key={value.cd}>{value.code_value1}</span>
                                                                                            ))}
                                                                                        <div>{task.task_detail}</div>
                                                                                    </>
                                                                                )}
                                                                                {task.t_client_id !== 0 && task.name_abbreviation && <span>[{task.name_abbreviation}]</span>}
                                                                                <a href={`/projectDetails/${task.t_project_id}`}>{task.project_name_abbreviation}</a>
                                                                                <span style={{ color: '#9dad01', fontWeight: 'bold' }}>
                                                                                    {task.progress_rate !== '0' && task.progress_rate ? `[${task.progress_rate}%]` : null}
                                                                                </span>
                                                                            </span>
                                                                            <div className="comment" style={{ whiteSpace: "pre-line"}}>
                                                                                <div>{task.t_project_id !== 0 && task.t_client_id !== 0 ? task.task_detail : null}</div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })
                                                        ) : (
                                                            <span>The work task does not exist</span>
                                                        )}
                                                    </td>
                                                    {val.task_list && val.task_list.length > 0 && (
                                                        <td className="mamemo" key={`memo-${val.daily_work_id}`}>
                                                            <div className="comment" val={val.daily_memo} style={{ whiteSpace: "pre-line",margin: '5px 0px 5px 5px' }}>
                                                                {val.daily_memo}
                                                            </div>
                                                            <div className="comment_btn">
                                                                <img
                                                                    src={commentIcon}
                                                                    alt="コメント"
                                                                    data-btntag="2"
                                                                    data-id={val.daily_work_id}
                                                                    data-user-id={val.id}
                                                                    daily-memo={val.daily_memo}
                                                                    className="jq-mame-comment-popup"
                                                                    onClick={clickCommentBtn}
                                                                />
                                                                <span className="counts" id={`commentcount_up_${val.daily_work_id}`}>
                                                                    &nbsp;({val.comment_count})
                                                                </span>
                                                            </div>
                                                        </td>
                                                    )}
                                                </tr>
                                            </tbody>
                                        ))
                                ) : (
                                    <tbody><tr><td colSpan="3">No tasks available</td></tr></tbody>
                                )}
                            </table>
                        ) : (
                            <p>The work task does not exist</p>
                        )}
                    </section>
                    </>}
                    
                </div>
                {/* Popup */}
                {isPopupOpen && (
                    <>
                        <div className="overlay show"></div>
                        <CommentPopup
                            isOpen={isPopupOpen}
                            togglePopup={togglePopup}
                            dailyWorkId={dailyWorkId}
                            tUserId={tUserId}
                            loginUserID={loginUserId}
                            dailyMemo={dailyMemo}
                        />
                    </>
                )}
            </div>
            <ScrollTop />
        </div>
    );
};

export default ScheduleList;
